import { IProjectBuilder, IProjectBuilderOptions } from '../types';

import { createProjectBuilder } from '../generator/ProjectBuilder';

import esmodule from '../plugins/common/esmodule';
import styleImport from '../plugins/common/styleImport';
import containerClass from '../plugins/component/react/containerClass';
import containerFunction from '../plugins/component/react/containerFunction';
import containerInitState from '../plugins/component/react/containerInitState';
import containerInjectContext from '../plugins/component/react/containerInjectContext';
import containerInjectUtils from '../plugins/component/react/containerInjectUtils';
import containerInjectDataSourceEngine from '../plugins/component/react/containerInjectDataSourceEngine';
import containerInjectConstants from '../plugins/component/react/containerInjectConstants';
import containerInjectI18n from '../plugins/component/react/containerInjectI18n';
import containerLifeCycle from '../plugins/component/react/containerLifeCycle';
import containerMethod from '../plugins/component/react/containerMethod';
import jsx from '../plugins/component/react/jsx';
import reactCommonDeps from '../plugins/component/react/reactCommonDeps';
import css from '../plugins/component/style/css';
import constants from '../plugins/project/constants';
import i18n from '../plugins/project/i18n';
import utils from '../plugins/project/utils';

import gantLegacy from '../plugins/project/framework/gant-legacy';

import { prettier } from '../postprocessor';
import containerStatement from '../plugins/component/react/containerStatement';
import functionJsx from '../plugins/component/react/functionJsx';
import containerState from '../plugins/component/react/containerState';

export type GantProjectBuilderOptions = IProjectBuilderOptions;

export default function createGantChunkProjectBuilder(
  options?: GantProjectBuilderOptions,
): IProjectBuilder {
  return createProjectBuilder({
    mode: options?.mode,
    inStrictMode: options?.inStrictMode,
    rootPaths: options?.rootPaths,
    pagePaths: options?.pagePaths,
    configPaths: options?.configPaths,
    extraContextData: { ...options },
    template: gantLegacy.template,
    plugins: {
      components: [
        reactCommonDeps(),
        esmodule({
          fileType: 'tsx',
        }),
        containerInjectUtils(),
        styleImport(),
        containerFunction(),
        containerState(),
        containerStatement(),
        functionJsx({
          nodeTypeMapping: {
            Div: 'div',
            Component: 'div',
            Page: 'div',
            Block: 'div',
          },
        }),
        css(),
      ],
      pages: [
        reactCommonDeps(),
        esmodule({
          fileType: 'tsx',
        }),
        containerInjectUtils({ scope: 'pages' }),
        styleImport(),
        containerFunction(),
        containerState(),
        containerStatement(),
        functionJsx({
          nodeTypeMapping: {
            Div: 'div',
            Component: 'div',
            Page: 'div',
            Block: 'div',
            // Box: 'div',
          },
        }),
        css(),
      ],
      router: [esmodule(), gantLegacy.plugins.router()],
      entry: [gantLegacy.plugins.entry()],
      constants: [constants()],
      utils: [esmodule(), utils('react')],
      i18n: [i18n()],
      globalStyle: [gantLegacy.plugins.globalStyle()],
      packageJSON: [gantLegacy.plugins.packageJSON()],
      config: [gantLegacy.plugins.lowcodeConfigJSON()],
    },
    postProcessors: [prettier()],
    customizeBuilderOptions: options?.customizeBuilderOptions,
  });
}

export const plugins = {
  containerClass,
  containerInjectContext,
  containerInjectUtils,
  containerInjectDataSourceEngine,
  containerInjectI18n,
  containerInjectConstants,
  containerInitState,
  containerLifeCycle,
  containerMethod,
  jsx,
  commonDeps: reactCommonDeps,

  /** @deprecated Please use commonDeps */
  reactCommonDeps,
};
